import { Component, HostBinding, Input } from '@angular/core';

type SkeletonVariant = 'line' | 'circle' | 'rect';

@Component({
  selector: 'app-skeleton-loader',
  standalone: true,
  template: '',
  styleUrls: ['skeleton-loader.component.scss'],
  host: { class: 'skeleton' }
})
export class SkeletonLoaderComponent {
  @Input() variant: SkeletonVariant = 'line';
  @Input() width: string;
  @Input() height: string;

  @HostBinding('class.skeleton--line')   get isLine()   { return this.variant === 'line'; }
  @HostBinding('class.skeleton--circle') get isCircle() { return this.variant === 'circle'; }
  @HostBinding('class.skeleton--rect')   get isRect()   { return this.variant === 'rect'; }

  @HostBinding('style.width')  get styleWidth()  { return this.width; }
  @HostBinding('style.height') get styleHeight() { return this.height; }
}
